import { useContext, useEffect, useState } from 'react';

import { DataContext } from '../../context/DataContext';
import { RouterContext } from '../../context/RouterContext';

import useFetchHook from '../../hooks/customHook';

import { htmlMsg } from '../../helpers/swal_msg';
import { saveFormData } from '../../actions/mainForm';
import { form1Validator } from '../../validators/MainFormValidator';

//CSS
import './Index.css';

import Institution from './Institution';

//MUI
import {
    Box, Button, Container, FormControl, Grid2, InputLabel,
    MenuItem, Select, TextField, Typography
} from '@mui/material'
import { styled } from "@mui/material/styles";

import { FORM_INIT, INSTI_INIT } from '../../constants/form_const';
import { regex_num, regex_phone } from '../../constants/regex';

const AddButton = styled(Button)(({ theme }) => ({
    color: '#fff',
    backgroundColor: '#56C596',
    textTransform: 'none',
    padding: '10px',
    fontWeight: '600',
    '&:hover': {
        backgroundColor: '#358f69',
        color: '#fff'
    }
}));

const SubmitButton = styled(Button)(({ theme }) => ({
    color: '#fff',
    backgroundColor: '#67A4DE',
    textTransform: 'none',
    padding: '10px',
    fontWeight: '600',
    '&:hover': {
        backgroundColor: '#4277a8',
        color: '#fff'
    }
}));

const name_regex = /^([^0-9]*)$/;

const Index = () => {
    const { item: { username } } = useContext(RouterContext);
    const { data: { specialties, institution_types } } = useContext(DataContext);

    const { protectedFetchReq } = useFetchHook();

    const [userInfo, setUserInfo] = useState(FORM_INIT);
    const { name, professionalID, email, phone, especialidad } = userInfo;

    const [formValues, setFormValues] = useState([INSTI_INIT]);

    const [fieldError, setFieldError] = useState({
       phone_err: false 
    });
    const { phone_err } = fieldError;

    // información recuperada con el código postal
    // colonias disponibles para campo de envío
    const [colonies, setColonies] = useState([[]]);

    useEffect(() => {
        setFieldError(
            e => ({
                ...e, phone_err: regex_phone.test(phone) ? false : true
            })
        );
    }, [phone]);

    const handleChange = ({ target }) => {
        const name = target.name
        const value = target.value;
        if (name === 'name') {
            if (value === '' || name_regex.test(value))
                setUserInfo(e => ({
                    ...e,
                    [name]: value
                }));
        } else if (['phone', 'professionalID'].includes(name)) {
            if (value === '' || regex_num.test(value))
                setUserInfo(e => ({
                    ...e,
                    [name]: value
                }));
        } else if (name === 'email')
            setUserInfo(e => ({
                ...e,
                [name]: value.toLowerCase()
            }));
        else
            setUserInfo(e => ({
                ...e,
                [name]: value
            }));
    };

    // nueva institución
    const addFormFields = () => {
        setFormValues([...formValues, INSTI_INIT]);
        setColonies(e => ([...e, []]));
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        const { status, msg } = form1Validator(userInfo, formValues);
        if (status)
            await saveFormData(
                username, userInfo, formValues, setUserInfo,
                setFormValues, protectedFetchReq
            );
        else {
            let html = '';
            for (const e of msg) {
                html += `<p>${e}</p>`;
            };
            htmlMsg('info', 'Complete la siguiente información', html);
        }
    };

    return (
        <Container maxWidth='xl' sx={{ my: 8 }}>
            <form onSubmit={handleSubmit}>

                <Typography variant='h4' textAlign='center' sx={{ color: '#66A3DC', fontWeight: 'bold' }}>
                    Registro de profesionales médicos
                </Typography>

                <Box sx={{ mt: 5, p: 3 }} className='medic_info'>
                    <Typography variant='h6' sx={{ fontWeight: '600', mb: 3 }}>
                        Información del Médico
                    </Typography>
                    <Grid2 container spacing={4}>
                        <Grid2 size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }}>
                            <TextField label='Nombre' variant='outlined' fullWidth size='small' name='name' value={name} onChange={handleChange} />
                        </Grid2>

                        <Grid2 size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }}>
                            <TextField label='Cédula profesional' variant='outlined' fullWidth size='small' name='professionalID' value={professionalID} onChange={handleChange}
                                slotProps={{ htmlInput: { maxLength: 8 } }}
                            />
                        </Grid2>

                        <Grid2 size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }}>
                            <TextField label='Correo electrónico' variant='outlined' fullWidth size='small' name='email' value={email} onChange={handleChange} />
                        </Grid2>

                        <Grid2 size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }}>
                            <TextField label='Teléfono' variant='outlined' fullWidth size='small' name='phone' value={phone} onChange={handleChange}
                                slotProps={{ htmlInput: { maxLength: 10 } }} helperText={ phone_err ? "Introduzca un número válido" : "" }
                            />
                        </Grid2>

                        <Grid2 size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }}>
                            <FormControl fullWidth size='small'>
                                <InputLabel id="especialidad">Seleccione una especialidad</InputLabel>
                                <Select
                                    labelId="especialidad"
                                    label="Seleccione una especialidad"
                                    name='especialidad'
                                    value={especialidad}
                                    onChange={handleChange}
                                >

                                    {
                                        specialties.map(({ idEspecialidad, nombreEspecialidad }) =>
                                            <MenuItem key={idEspecialidad}
                                                value={idEspecialidad}>
                                                { nombreEspecialidad }
                                            </MenuItem>
                                        )
                                    }
                                </Select>
                            </FormControl>
                        </Grid2>
                    </Grid2>
                </Box>

                <Institution
                    formValues={formValues}
                    setFormValues={setFormValues}
                    colonies={colonies}
                    setColonies={setColonies}
                    institution_types={institution_types}
                />
                <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-start', gap: '18px', flexWrap: 'wrap' }}>
                    <AddButton variant='contained' onClick={() => addFormFields()}>Agregar otra institución</AddButton>
                    <SubmitButton type='submit'>Guardar</SubmitButton>
                </Box>
            </form>
        </Container>
    );
};

export default Index;